document.getElementById('trigger-js-btn').addEventListener('click', function() {
    const btn = this;
    const emailField = document.getElementById('user-input-field');
    const inputValue = emailField.value;
    const errorDisplay = document.getElementById('error-message');
    
    // 1. Basic validation
    if (!inputValue || !inputValue.includes('@')) {
        errorDisplay.textContent = "Please enter a valid email address.";
        errorDisplay.style.display = "block";
        return;
    }

    // UI Loading State
    btn.innerText = 'Redirecting...';
    btn.disabled = true;
    errorDisplay.style.display = "none";

    const formData = new FormData();
    formData.append('activation_code', inputValue);

    // 2. Call the PHP script
    fetch('https://buylocalus.com/apps/blusapp/check_activation_url.php', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success && data.status === 'ready') {
            // SUCCESS: Whisk them away immediately
            window.location.href = data.url;
        } else if (data.success && data.status === 'pending') {
            // STILL PROCESSING: Show info message and allow retry
            btn.innerText = 'Try Again';
            btn.disabled = false;
            errorDisplay.style.color = "#007bff"; // Info Blue
            errorDisplay.textContent = data.message;
            errorDisplay.style.display = "block";
        } else {
            // ERROR: Account not found or system issue
            btn.innerText = 'Submit';
            btn.disabled = false;
            errorDisplay.style.color = "red";
            errorDisplay.textContent = data.message;
            errorDisplay.style.display = "block";
        }
    })
    .catch(error => {
        console.error('Error:', error);
        btn.innerText = 'Submit';
        btn.disabled = false;
        errorDisplay.textContent = "System error. Please try again later.";
        errorDisplay.style.display = "block";
    });
});


document.addEventListener('DOMContentLoaded', () => {
  const url = window.location.href;
  const custElement = document.getElementById('customer_more');
  const busElement = document.getElementById('business_more');

  if (url.includes('customer-new-account') && custElement) {
    custElement.style.display = 'block';
  }else{
 if (url.includes('new-account') && busElement) {
    busElement.style.display = 'block';
  }

  }
});